module.exports = __webpack_public_path__ + "static/media/Image1.7d44356e.jpeg";